import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-currencyfmt-number-input',
  templateUrl: './currencyfmt-number-input.component.html',
  styleUrls: ['./currencyfmt-number-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CurrencyfmtNumberInputComponent),
      multi: true,
    },
  ],
})
export class CurrencyfmtNumberInputComponent
  implements OnInit, AfterViewInit, ControlValueAccessor
{
  @Input('currencySymbol') currencySymbol: string = '';
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;
  @Input() ngClass: any;
  private _value: number;
  viewNumber: number;
  nf: Intl.NumberFormat;

  @ViewChild('inputEl') inputEl: ElementRef;

  constructor() {
    this.nf = new Intl.NumberFormat('en-US');
  }

  ngOnInit() {}
  ngAfterViewInit() {
    this.setInputView(this._value);
  }

  onChanged: any = () => {};
  onTouched: any = () => {};

  writeValue(value: number): void {
    this.setFormattedValue(value);
  }
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set value(val) {
    console.log('here');
    this._value = val;
    this.onChanged(val);
    this.onTouched(val);
  }

  setFormattedValue(val) {
    val = val + '';
    val = val.replaceAll(',', '');
    this._value = val;
    this.onChanged(this.invalidNum(val));
    this.onTouched();
    this.setInputView(this.invalidNum(val));
  }

  invalidNum(val: number): number {
    if (isNaN(val)) return '' || Number('');
    else return val;
  }

  private setInputView(val) {
    if (this.inputEl && val !== null && val !== undefined && val !== '')
      this.inputEl.nativeElement.value = this.nf.format(val);
    // this.currencySymbol
  }
}
